//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { api_Coin1ExchangeCash, api_Coin1Ledger } from "../../../api";

export default {
  name: "Coin1Ledger",
  data() {
    return {
      balance: { available: 0, frozen: 0, total: 0 },
      items: [],
      changeType: "all",
      dateRange: [],
      nextCursor: null,
      hasMore: false,
      loading: false,
      exchangeCashInput: "",
      exchangeRate: 1,
      exchangeMinAmount: 1,
      exchangeDailyMaxCashAmount: 0,
      exchangeDailyExchangedCashAmount: 0,
      exchangeDailyRemainingCashAmount: 0,
      exchangeLoading: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    formatAmount(value) {
      return Number(value || 0).toFixed(2);
    },
    createRequestId() {
      return `coin1-exchange-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    },
    truncateAmount(value) {
      return Math.floor((value + 0.00000001) * 100) / 100;
    },
    exchangeCoin1AmountValue(value = this.exchangeCashInput) {
      const amount = Number(value);
      const rate = Number(this.exchangeRate || 0);
      if (!Number.isFinite(amount) || amount <= 0 || !Number.isFinite(rate) || rate <= 0) return 0;
      return this.truncateAmount(amount * rate);
    },
    exchangeCash() {
      const cashAmount = this.truncateAmount(Number(this.exchangeCashInput));
      if (!Number.isFinite(cashAmount) || cashAmount <= 0) {
        this.$Message.error("请输入正确的兑换余额数量");
        return;
      }
      const coin1Amount = this.exchangeCoin1AmountValue(cashAmount);
      const minAmount = Number(this.exchangeMinAmount || 0);
      const amountCents = Math.round(coin1Amount * 100);
      const minAmountCents = Math.round(minAmount * 100);
      if (!minAmountCents || amountCents < minAmountCents || amountCents % 100 !== 0) {
        this.$Message.error(`本次兑换消耗的金豆必须是整数，且不低于 ${this.formatAmount(minAmount)} 金豆`);
        return;
      }
      if (this.exchangeDailyMaxCashAmount > 0 &&
        this.exchangeDailyExchangedCashAmount + cashAmount > this.exchangeDailyMaxCashAmount) {
        this.$Message.error(`今日最多可兑换 ${this.formatAmount(this.exchangeDailyMaxCashAmount)} 余额，今日还可兑换 ${this.formatAmount(this.exchangeDailyRemainingCashAmount)} 余额`);
        return;
      }
      if (coin1Amount > Number(this.balance.available || 0)) {
        this.$Message.error("金豆余额不足");
        return;
      }
      this.exchangeLoading = true;
      api_Coin1ExchangeCash({ amount: cashAmount, requestId: this.createRequestId() }).then((res) => {
        if (res.data && res.data.success) {
          this.$Message.success("兑换成功");
          this.exchangeCashInput = "";
          this.$store.commit("setInfo");
          this.resetAndLoad();
        } else {
          this.$Message.error((res.data && res.data.message) || "兑换失败");
        }
      }).catch((error) => {
        this.$Message.error((error.response && error.response.data && error.response.data.message) || "兑换失败");
      }).finally(() => {
        this.exchangeLoading = false;
      });
    },
    signedAmount(value) {
      const amount = Number(value || 0);
      return `${amount >= 0 ? "+" : ""}${amount.toFixed(2)} 金豆`;
    },
    amountClass(item) {
      return item.amount >= 0 ? "amount-add" : "amount-sub";
    },
    typeClass(type) {
      return {
        AddAvailable: "type-add",
        DeductAvailable: "type-sub",
        Freeze: "type-freeze",
        Unfreeze: "type-unfreeze",
        DeductFrozen: "type-sub",
      }[type] || "";
    },
    formatTime(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString();
    },
    getDateParams() {
      if (!Array.isArray(this.dateRange) || this.dateRange.length !== 2 || !this.dateRange[0] || !this.dateRange[1])
        return {};
      const start = new Date(this.dateRange[0]);
      const end = new Date(this.dateRange[1]);
      end.setDate(end.getDate() + 1);
      return { start: start.toISOString(), end: end.toISOString() };
    },
    resetAndLoad() {
      this.items = [];
      this.nextCursor = null;
      this.hasMore = false;
      this.load();
    },
    loadMore() {
      this.load();
    },
    load() {
      if (this.loading) return;
      this.loading = true;
      const params = {
        limit: 20,
        changeType: this.changeType,
        ...(this.nextCursor ? { beforeId: this.nextCursor } : {}),
        ...this.getDateParams(),
      };
      api_Coin1Ledger(params).then((res) => {
        if (res.data && res.data.success) {
          const data = res.data.data || {};
          this.balance = {
            available: data.available || 0,
            frozen: data.frozen || 0,
            total: data.total || 0,
          };
          if (data.exchangeRate !== undefined) this.exchangeRate = Number(data.exchangeRate) || 1;
          if (data.exchangeMinAmount !== undefined) this.exchangeMinAmount = Number(data.exchangeMinAmount) || 1;
          if (data.exchangeDailyMaxCashAmount !== undefined) this.exchangeDailyMaxCashAmount = Number(data.exchangeDailyMaxCashAmount) || 0;
          if (data.exchangeDailyExchangedCashAmount !== undefined) this.exchangeDailyExchangedCashAmount = Number(data.exchangeDailyExchangedCashAmount) || 0;
          if (data.exchangeDailyRemainingCashAmount !== undefined) this.exchangeDailyRemainingCashAmount = Number(data.exchangeDailyRemainingCashAmount) || 0;
          this.items = this.nextCursor ? this.items.concat(data.items || []) : (data.items || []);
          this.nextCursor = data.nextCursor || null;
          this.hasMore = !!data.hasMore;
        } else if (res.data && res.data.msg) {
          this.$Message.error(res.data.msg);
        }
      }).catch(() => {
        this.$Message.error("获取金豆流水失败");
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  computed: {
    exchangeCoin1Amount() {
      return this.formatAmount(this.exchangeCoin1AmountValue());
    },
  },
};
